import * as service from '@/service/dataCleanup.service'

const state = {
  preview: [],
  logs: [],
}

const mutations = {
  SET_PREVIEW(state, payload) {
    state.preview = payload
  },
  SET_LOGS(state, payload) {
    state.logs = payload
  },
}

const actions = {
  validateOrders({ commit }, ids) {
    return service.validateOrders(ids).then(data => {
      commit('SET_PREVIEW', data.preview || [])
      return data
    })
  },
  executeOrderDeletion(_, { ids, warningsAcknowledged }) {
    return service.executeOrderDeletion(ids, warningsAcknowledged)
  },
  validateInventory(_, { storageIds, locationIds }) {
    return service.validateInventory(storageIds, locationIds)
  },
  executeInventoryDeletion(_, { storageIds, locationIds }) {
    return service.executeInventoryDeletion(storageIds, locationIds)
  },
  fetchDeletionLogs({ commit }) {
    return service.fetchDeletionLogs().then(logs => {
      commit('SET_LOGS', logs || [])
      return logs
    })
  },
  restoreOrder(_, logId) {
    return service.restoreOrder(logId)
  },
}

const getters = {
  cleanupPreview: state => state.preview,
  deletionLogs: state => state.logs,
}

export default {
  state, mutations, actions, getters,
}
